import React from 'react'
import { Label } from 'semantic-ui-react'
import { getQuestionStatus } from '../reducers/questions'
import Status from '../reducers/questions/status'

export const QuestionStatusLabel = ({ question_id, game_id, state }) => {
    const status = getQuestionStatus(question_id, game_id, state)
    switch (status) {
        case Status.WAITING_BET_ASKED:
        case Status.WAITING_BETS:
            return <Label tag>In attesa di scommesse</Label>

        case Status.TO_ASK:
            return <Label color='blue' tag>Da chiedere</Label>

        case Status.WAITING_ASKED:
        case Status.WAITING_ANSWERS:
            return <Label tag>In attesa di risposte</Label>

        case Status.ASKED:
            return <Label tag>Già chiesta</Label>

        default:
            return null
    }
}


// WEBPACK FOOTER //
// ./src/components/QuestionStatusLabel.js